module.exports = __webpack_public_path__ + "img/mission-impossible-2024.14ffcf17.jpg";